import { queryPremiumRateForHSUDR as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForHSUDR as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
